import React, { useEffect, useState } from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { PageHeader } from '../../shared/components';
import powerBIService from '../../services/powerBIService';
import { PowerBIReportDto } from '../../services/types/PowerBI';

const PowerBIReports: React.FC = () => {
  // console.log('PowerBIReport 2 component rendering...');
  const [report, setReport] = useState<PowerBIReportDto | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // console.log('call useEffect...');
    const fetchReport = async () => {
      try {
        // console.log('Fetching PowerBI report 2...');
        const data = await powerBIService.getReport2();
        setReport(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching E&S Grievance Insights report:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, []);

  if (loading) {
    return (
      <Container>
        <PageHeader title="E&S Grievance Insights" backUrl="/" />
        <div>Loading...</div>
      </Container>
    );
  }

  if (!report) {
    return (
      <Container>
        <PageHeader title="E&S Grievance Insights" backUrl="/" />
        <Card>
          <CardBody>
            <p>E&S Grievance Insights not available</p>
          </CardBody>
        </Card>
      </Container>
    );
  }

  return (
    <Container fluid className="powerbi-reports">
      <PageHeader title="E&S Grievance Insights" backUrl="/" />
      <Card>
        <CardBody>
          <iframe title={report.reportName} src={report.reportUrl} className="powerbi-iframe" />
        </CardBody>
      </Card>
    </Container>
  );
};

export default PowerBIReports;
